// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__i8LDM","spin":"Loader_spin__Fw2Xk"};